/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PaidEnum;

(function (PaidEnum) {
  PaidEnum["PAID"] = "paid";
  PaidEnum["TO_BE_PAID"] = "to_be_paid";
  PaidEnum["NEW_PREMIUM"] = "new_premium";
  PaidEnum["CANCELLED"] = "cancelled";
  PaidEnum["EXPIRED"] = "expired";
  PaidEnum["REFUND"] = "refund";
})(PaidEnum || (PaidEnum = {}));